import { AuthenticationService } from '../../services/authentication.service';
import { UserService } from '../../services/user.service';
import { Component, OnInit,Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { TitleCasePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { resolveCountryLabel } from 'src/app/shared/profile-contact.util';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  user: any;
  nombres: string = '';
  apellidos: string;
  email: string;
  codigo: string;
  telefono: string;
  fechanac: Date;
  genero: string;
  pais: string;
  uid: string;
  avatar: string;
  uid_in_userdatabase: any;
  currentuid: string;
  urlid: string;

  noMyUser: boolean = false;
  usuario: any;

  es: boolean = false;
  en: boolean = false;
  ar: boolean = false;
  idioma: boolean = false;
  click: boolean = false;
  colegioUid: any;

  datosMiUsuario:any;
  padres: any = [];

  constructor(
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private breadService: BreadcrumbService,
    private translate: TranslateService
  ) {}

  getUserRole(user: any): string {
    return user?.role || user?.role || '';
  }

  getUserName(user: any): string {
    return user?.name || user?.nombres || '';
  }

  getUserLastName(user: any): string {
    return user?.last_name || user?.apellidos || '';
  }

  getUsername(user: any): string {
    return user?.username || user?.usuario || user?.email || '';
  }

  private getUserGender(user: any): string {
    return user?.gender || user?.genero || '';
  }

  private getUserCountry(user: any): string {
    const language = this.translate.currentLang || this.translate.getDefaultLang() || 'es';
    return resolveCountryLabel(user?.country || user?.pais || '', language);
  }

  private getUserCode(user: any): string {
    return user?.code || user?.codigo || '';
  }

  private getUserPhone(user: any): string {
    return user?.phone_number || user?.phone || user?.telefono || '';
  }

  private getSchoolIds(user: any): string[] {
    return user?.schools || user?.colegios || [];
  }

  private parseDate(value: any): Date | null {
    if (!value) return null;
    if (value.seconds !== undefined) return new Date(value.seconds * 1000);
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  private loadProfileUser(user: any, uid: string, uidInDatabase?: string): void {
    this.user = user;
    this.uid = uid;
    this.uid_in_userdatabase = uidInDatabase || this.uid_in_userdatabase;
    this.avatar = user?.avatar || '';
    this.nombres = this.getUserName(user);
    this.apellidos = this.getUserLastName(user);
    this.genero = this.getUserGender(user);
    this.pais = this.getUserCountry(user);
    this.fechanac = this.parseDate(user?.date_of_birth || user?.birth_date || user?.fechanac);
    this.telefono = this.getUserPhone(user);
    this.email = user?.email || '';
    this.codigo = this.getUserCode(user);
    this.usuario = this.getUsername(user);
    this.colegioUid = this.getSchoolIds(user)[0] || '';
    this.padres = user?.parents || user?.padres || [];
  }

  ngOnInit() {
    if (localStorage.getItem('idioma')) {
      var lang = localStorage.getItem('idioma');

      switch (lang) {
        case 'es':
          this.es = true;
          break;
        case 'en':
          this.en = true;
          break;
        case 'ar':
          this.ar = true;
          break;
        default:
          break;
      }
    } else {
      this.es = true;
    }

    this.urlid = this.activatedRoute.snapshot.params['uid'];

    this.authenticationService.getStatus().subscribe(
      (status) => {
        this.currentuid = status.uid;
        if (this.urlid != status.uid) {
          this.noMyUser = true;
          this.userService
            .getUserById(status.uid)
            .pipe(take(1))
            .subscribe((data) => {
              if (data[0]) {
                this.user = data[0].payload.doc.data();
             
              }
            });
          this.userService
            .getUserById(this.urlid)
            .pipe(take(1))
            .subscribe((data) => {
              if (data[0]) {
                var use = data[0].payload.doc.data();
                this.loadProfileUser(use, this.urlid, data[0].payload.doc.id);
              }
            });
        } else {
          this.noMyUser = false;
          this.userService
            .getUserById(this.urlid)
            .pipe(take(1))
            .subscribe(
              (data) => {
                if (data[0]) {
                  this.loadProfileUser(data[0].payload.doc.data(), this.urlid, data[0].payload.doc.id);
                }
              },
              (error) => {
                console.log(error);
              }
            );
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.userService.getUserinfo().subscribe((data: any) => {
      const user = data?.payload?.doc?.data ? data.payload.doc.data() : data;
      const uid = user?.uid || data?.payload?.doc?.id;

      if (!user || !uid) {
        return;
      }

      if (!this.noMyUser && this.urlid === uid) {
        this.loadProfileUser(user, uid, data?.payload?.doc?.id);
      }
    });

    // const Userdata: any = this.userService.getUserinfodata();

    // if (Userdata === undefined) {
    //   this.authenticationService.isAuth().subscribe((auth) => {
    //     if (auth) {
    //       const userUid = auth.uid;

    //       this.userService.getUserById(userUid).pipe(take(1)).subscribe((userdata) => {
    //         if (userdata[0].payload.doc.data()) {
    //           this.datosMiUsuario = userdata[0].payload.doc.data();
    //           console.log('datosmiusuario', this.datosMiUsuario);
    //         }
    //       });
    //     }
    //   });

    //   // this.getCurrentUser();
    // } else {
    //   this.datosMiUsuario = Userdata.payload.doc.data();
    //   console.log('datosmiusuario', this.datosMiUsuario);
    // }
  }
  UpdateBreadcrumb(name, url) {
    this.breadService.addtobread(name, url);
  }
  get chaturl() {
    return [this.uid, this.urlid].sort().join('|');
  }

  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('idioma', lang);
  }

  espanol() {
    this.translate.use('es');
    this.es = true;
    this.en = false;
    this.ar = false;
    localStorage.setItem('idioma', 'es');
    this.activeLanguage();
  }

  ingles() {
    this.translate.use('en');
    this.en = true;
    this.es = false;
    this.ar = false;
    localStorage.setItem('idioma', 'en');
    this.activeLanguage();
  }

  arabe() {
    this.translate.use('ar');
    this.en = false;
    this.es = false;
    this.ar = true;
    localStorage.setItem('idioma', 'ar');
    this.activeLanguage();
  }

  changeColor() {
    this.click = !this.click;
  }

  activeLanguage() {
    this.idioma ? (this.idioma = false) : (this.idioma = true);
    console.log('hola', this.idioma);
  }
}
